export { type FooterLogosProps, default as FooterLogos } from './FooterLogos';
